<template>
  <div class="info-wrap">
    <div class="info-content">
      <TitleCard
        :titles="titles"
        :defaultSelected="defaultSelectedId"
        isSwitch
        :showMore="false"
        @switchTitle="switchTitleHandle"
      >
        <InfoList
          :contentList="contentList"
          :tag="tag"
          :code="code"
          :selectedId="selectedId"
        ></InfoList>
      </TitleCard>
      <Pagination
        ref="pagination"
        :paginationOpt="paginationOpt"
        :total="total"
        @change="handlerPaginationChange"
        :pageSize="paginationOpt.pageSize"
        :pageNum="paginationOpt.pageNum"
        v-if="total > 0"
      ></Pagination>
      <div class="noData" v-if="total <= 0">
        <img src="../../../public/static/nodata.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import InfoList from './components/infoList/index.vue'
import Pagination from '@/components/common/Pagination'
import { mapGetters } from 'vuex'
import { titles } from './config'
import { getFrontAchievementExhibition } from "@/api/AchievementExhibition.js";

export default {
  data() {
    return {
      titles,
      defaultSelectedId: null, // 默认的选中id'
      selectedId: null,
      total: 0,
      // 最初的请求数据的分页参数
      paginationOpt: {
        pageNum: 1,
        pageSize: 10
      },
      contentList: [],
      tag: '',
      code: ''
    }
  },
  components: {
    InfoList,
    Pagination
  },
  computed: {
    ...mapGetters('headerMenu', [
      'setUpdateMenuList'
    ]),
    menuList() {
      return this.setUpdateMenuList
    }
  },
  watch: {},
  mounted() {
    this.init()
  },
  methods: {
    init() {
      let { selectedId } = this.$route.query
      if (selectedId) { // 从详情的面包屑跳转出来的
        this.titles.forEach(ele => {
          if (Number(ele.id) === Number(selectedId)) {
            this.tag = ele.label
            this.code = ele.code
            this.defaultSelectedId = ele.id
          }
        })
      } else { // 第一次进来选中的tab
        this.tag = this.titles[0].label
        this.code = this.titles[0].code
        this.defaultSelectedId = this.titles[0].id
      }
      this.selectedId = this.defaultSelectedId
      let params = {
        code: this.code
      }
      this.commonInit(params)
    },
    async commonInit(val) {
      const { rows, total } = await getFrontAchievementExhibition({ ...val }, { ...this.paginationOpt })
      this.contentList = rows
      this.total = total
    },
    switchTitleHandle(val) {
      this.selectedId = val.id
      this.tag = val.label
      this.code = val.code
      let params = { code: val.code }
      this.paginationOpt.pageNum = 1
      this.paginationOpt.pageSize = 10
      this.commonInit(params)
    },
    handlerPaginationChange(val) {
      this.paginationOpt.pageNum = val.current
      this.paginationOpt.pageSize = val.pageSize || this.$refs.pagination.currentSize
      let params = { code: this.code }
      this.commonInit(params)
    }
  }
}
</script>

<style>
</style>
